import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedDate } from 'react-intl';
import { combinedSVGIcons } from 's2s-svg-icons-combined';
import { ArrowDownLeftIconSVG, ArrowUpRightIconSVG, AlertIconSVG } from 's2s-svg-icons';// incoming calls
import { colorGrid } from 's2s-themes';

const CallHistoryItemContainer = styled.div`
  background-color: ${colorGrid.gray0};
  box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.1), inset 0 1px 0 0 rgba(0, 0, 0, 0.1);
  color: ${colorGrid.gray9};
  cursor: pointer;
  display: flex;
  height: 64px;
  justify-content: flex-start;
  padding: 0 20px 0 10px;
`;

const SVGContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-right: 10px;
  width: 32px;
`;

const alertSVGStyles = {
  fill: '#C70816',
  height: '22px',
  width: '22px'
};

const CallInformation = styled.div`
  width : 100%;
  height: 64px;
`;

// Contains information for Name/ID that is displayed
const TopInformationContainer = styled.div`
  display: flex;
  font-size: 18px;
  font-weight: 900;
  padding-top: 10px;
`;

const CallerIDNameContainer = styled.div`
  max-width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #001221;
`;

// Contains information for caller extension and date
const BottomInformationContainer = styled.div`
  align-items: flex-end;
  color: ${colorGrid.gray5}
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
`;


const CallerExtension = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${colorGrid.gray6}
`;

const DateContainer = styled.div`
  display: flex;
  font-size: 14px;
  justify-content: flex-end;
  color: #4C5863;
`;

const directionSvgMap = {
  'inbound': combinedSVGIcons.PhoneCallbackRounded,
  'outbound': combinedSVGIcons.LocalPhoneRounded,
};

const CallHistoryItem = (props) => {
  const {theme} = props;
  const callSVGStyles = {
    fill: theme.history.default.iconRegularColor,
    height: '22px',
    width: '22px'
  };
  const onKeyDown = (e) => {
    switch (e.keyCode) {
      case 32:
        props.cbClick(props.callerNumber);
        break;
      case 13:
        props.cbClick(props.callerNumber);
        break;
      default:
        console.log("CallHistoryItem onKeyDown default case. Neither the Space or Enter key were pressed.");
    }
  };
  const itemClicked = () => {
    props.cbClick(props.callerNumber);
  };
  const CallSVG = directionSvgMap[props.direction.toLowerCase()];
  const callerNameNbr = !props.callerName ? (props.callerNumber) : props.callerName;
  const showExtNbr = !props.callerName ? undefined : props.callerNumber;

  return (
    <CallHistoryItemContainer
      className="CallHistoryItemContainer"
      aria-label="call detail"
      onClick={itemClicked}
      onKeyDown={onKeyDown}
      role="listitem"
      tabIndex="0"
    >
      <SVGContainer className="SVGContainer">
        {props.isCallFailed ? (
          <combinedSVGIcons.PhoneMissedRounded
            className="alertSVG"
            svgStyle={alertSVGStyles}
          />) : (
            <CallSVG
              className={props.direction}
              svgStyle={callSVGStyles}
            />
          )}
      </SVGContainer>
      <CallInformation className="callInformation">
        <TopInformationContainer className="TopInformation" >
          <CallerIDNameContainer className="callerIdNameContainer" >
            {callerNameNbr}
          </CallerIDNameContainer>
        </TopInformationContainer>
        <BottomInformationContainer className="bottomInformation" >
          <CallerExtension className="callerExt" >
            {showExtNbr}
          </CallerExtension>
          <DateContainer className="DateContainer" >
            <FormattedDate
              value={props.timestamp}
              hour="numeric"
              minute="2-digit"
              hour12
            />
          </DateContainer>
        </BottomInformationContainer>
      </CallInformation>
    </CallHistoryItemContainer>
  );
};

//
CallHistoryItem.propTypes = {
  callCount: PropTypes.number,
  callerName: PropTypes.string,
  callerNumber: PropTypes.string, //callers number or ext
  //The empty string is to allow no status to be passed when appropriate
  cbClick: PropTypes.func.isRequired,
  direction: PropTypes.oneOf(["inbound", "outbound", undefined]),
  isCallFailed: PropTypes.bool,
  timestamp: PropTypes.number
};

CallHistoryItem.defaultProps = {
  callCount: undefined,
  callerName: undefined,
  callerNumber: undefined,
  cbClick: () => { console.log('cbClick is not defined in callHistoryItem.'); },
  direction: undefined,
  isCallFailed: false,
  timestamp: Date.now()
};


export default CallHistoryItem;
